@let view = mode();
@let phase = clock.phase();
@let start = clock.windowStart();
@let end = clock.windowEnd();
@let elapsed = clock.elapsedLabel();
@let remaining = clock.remainingLabel();
@let overrun = clock.overrunLabel();
@let inWindow = phase === 'running' || phase === 'overrun';

<ng-template #elapsedPill>
  @if (elapsed) {
    <span
      class="mt-pill mt-pill--elapsed"
      [andorTooltip]="'Connected for [time]' | translate: { time: elapsed }"
      [tooltipPosition]="tooltipPosition()">
      <fa-duotone-icon class="mt-icon" [icon]="faClock"></fa-duotone-icon>
      <span class="mt-value">{{ elapsed }}</span>
    </span>
  }
</ng-template>

<ng-template #windowPill>
  @if (start !== null && end !== null) {
    <span
      class="mt-pill mt-pill--window mt-pill--{{ phase }}"
      [andorTooltip]="'Scheduled' | translate"
      [tooltipPosition]="tooltipPosition()">
      <fa-duotone-icon class="mt-icon" [icon]="faCalendarClock"></fa-duotone-icon>
      @switch (phase) {
        @case ('upcoming') {
          <span class="mt-value">
            {{ 'Starts in [time]' | translate: { time: remaining } }}
          </span>
        }
        @case ('ended') {
          <span class="mt-value">{{ 'Ended' | translate }}</span>
        }
        @default {
          <span class="mt-value">
            @if (!clock.windowIsToday()) {
              {{ start | localizedDate: 'shortWeekday' }}
            }
            {{ start | localizedDate: 'shortTime' }} – {{ end | localizedDate: 'shortTime' }}
          </span>
        }
      }
    </span>
  }
</ng-template>

<ng-template #overrunBadge>
  @if (overrun) {
    <span
      class="mt-overrun"
      role="timer"
      [andorTooltip]="'Over the scheduled end' | translate"
      [tooltipPosition]="tooltipPosition()">
      <fa-duotone-icon class="mt-overrun__icon" [icon]="faHourglassEnd"></fa-duotone-icon>
      <span class="mt-value">{{ overrun }}</span>
    </span>
  }
</ng-template>

@switch (view) {
  @case ('pills') {
    <div class="meeting-time meeting-time--pills">
      <ng-container [ngTemplateOutlet]="elapsedPill" />
      <ng-container [ngTemplateOutlet]="windowPill" />
      <ng-container [ngTemplateOutlet]="overrunBadge" />
    </div>
  }
  @case ('chip') {
    <div class="meeting-time meeting-time--chip">
      @if (overrun) {
        <ng-container [ngTemplateOutlet]="overrunBadge" />
      } @else if (phase === 'running' && remaining) {
        <span
          class="mt-pill mt-pill--running"
          [andorTooltip]="'Scheduled' | translate"
          [tooltipPosition]="tooltipPosition()">
          <fa-duotone-icon class="mt-icon" [icon]="faCalendarClock"></fa-duotone-icon>
          <span class="mt-value">{{ '[time] left' | translate: { time: remaining } }}</span>
        </span>
      } @else if (phase === 'upcoming') {
        <ng-container [ngTemplateOutlet]="windowPill" />
      } @else {
        <ng-container [ngTemplateOutlet]="elapsedPill" />
      }
    </div>
  }
  @case ('progress') {
    @if (inWindow) {
      <div
        class="meeting-time--progress"
        [class.is-overrun]="phase === 'overrun'"
        aria-hidden="true">
        <span class="mt-progress__fill" [style.width.%]="clock.progress() * 100"></span>
      </div>
    }
  }
}
